import React from 'react';
import { TagSelectOptionProps, TagOptionRecord } from '../types';
import { nullFn, getOptionProperty } from '../utils';
import CheckboxInput from './CheckboxInput';

function TagSelectOption<T extends TagOptionRecord>({
  id,
  keyField = 'id',
  option,
  valueField = 'label',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  optionIdx,
  selected,
  onOptionsSelected = nullFn,
}: TagSelectOptionProps<T>): JSX.Element {
  const optionRef = React.useRef<HTMLLIElement>(null);

  const handleOptionSelected = (evt: React.MouseEvent<HTMLLIElement>) => {
    evt.preventDefault();
    onOptionsSelected({
      type: 'SELECT_SINGLE_OPTION',
      option,
      isSelected: selected,
      keyField,
    });
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <li
      id={`options-${id}`}
      ref={optionRef}
      role='option'
      aria-selected={selected}
      onClick={handleOptionSelected}
      className={`flex cursor-pointer select-none flex-row items-center justify-between px-4 py-2 text-base tracking-tight text-gray-dark ${
        selected ? 'bg-green-light' : 'bg-white'
      }`}
    >
      {getOptionProperty(option, valueField)}
      <CheckboxInput
        name={`option-${id}`}
        checked={selected}
        disabled={false}
      />
    </li>
  );
}

export default TagSelectOption;
